import alertService from "../../services/alert/alert.service";
import chargePointService from "../../services/http/chargePoint.service";
import { chargePointActionTypes } from "../actionTypes/chargePoint.actionTypes";

export const resetSelectedChargePoint = () => async (dispatch) => {
  dispatch({ type: chargePointActionTypes.RESET_SELECTED_CHARGE_POINT });
};

export const getChargePointBySerialNumber = (serialNumber, conenctorNumber) => async (dispatch) => {
  let response;
  dispatch({ type: chargePointActionTypes.START_GET_CHARGE_POINT });
  try {
    response = await chargePointService.getChargePointBySerialNumber(serialNumber, conenctorNumber);

    dispatch({
      type: chargePointActionTypes.GET_CHARGE_POINT_SUCCESS,
    });
  } catch (error) {
    response = error?.response;
    dispatch({
      type: chargePointActionTypes.GET_CHARGE_POINT_FAILURE,
      payload: error.message || "Failed to fetch charge point.",
    });
    response = error;
  }
  return response?.data;
};

export const getChargePointDetails = (chargePointId) => async (dispatch) => {
  let response;
  dispatch({ type: chargePointActionTypes.START_GET_CHARGE_POINT });
  try {
    response = await chargePointService.getChargePointDetails(chargePointId);

    dispatch({
      type: chargePointActionTypes.GET_CHARGE_POINT_SUCCESS,
      payload: response.data.payload, // assuming `response.data` contains the charge point info
    });
  } catch (error) {
    response = error?.response;
    dispatch({
      type: chargePointActionTypes.GET_CHARGE_POINT_FAILURE,
      payload: error.message || "Failed to fetch charge point.",
    });
  }
  return response?.data;
};

export const getChargePointDetailsByExternalIdentifiers = (partyId, uid, connectorNumber) => async (dispatch) => {
  let response;
  dispatch({ type: chargePointActionTypes.START_GET_CHARGE_POINT });
  try {
    response = await chargePointService.getChargePointDetailsByExternalIdentifiers(partyId, uid, connectorNumber);

    dispatch({
      type: chargePointActionTypes.GET_CHARGE_POINT_SUCCESS,
      payload: response.data.payload,
    });
  } catch (error) {
    response = error?.response;
    dispatch({
      type: chargePointActionTypes.GET_CHARGE_POINT_FAILURE,
      payload: error.message || "Failed to fetch charge point.",
    });
  }
  return response?.data;
};

export const startChargingTransaction = (clientId, chargePointId, paymentTokenId) => async (dispatch) => {
  let response;
  dispatch({ type: chargePointActionTypes.START_CHARGING_TRANSACTION_REQUEST });
  try {
    response = await chargePointService.startChargingTransaction(clientId, chargePointId, paymentTokenId);

    dispatch({ type: chargePointActionTypes.START_CHARGING_TRANSACTION_SUCCESS });
  } catch (error) {
    response = error?.response;
    dispatch({
      type: chargePointActionTypes.START_CHARGING_TRANSACTION_FAILURE,
      payload: error.message || "Failed to fetch start charging transaction.",
    });
  }
  return response?.data;
};

export const stopChargingTransaction = (token) => async (dispatch) => {
  let response;
  dispatch({ type: chargePointActionTypes.STOP_CHARGING_TRANSACTION_REQUEST });
  try {
    response = await chargePointService.stopChargingTransaction(token);

    dispatch({ type: chargePointActionTypes.STOP_CHARGING_TRANSACTION_SUCCESS });
  } catch (error) {
    response = error?.response;
    dispatch({
      type: chargePointActionTypes.STOP_CHARGING_TRANSACTION_FAILURE,
      payload: error.message || "Failed to fetch stop charging transaction.",
    });
  }
  return response?.data;
};

export const getOpenChargingTransactionToken = (chargePointId, identificationValue, last4Digit) => async (dispatch) => {
  let response;
  dispatch({ type: chargePointActionTypes.START_GET_OPEN_CHARGING_TRANSACTION });
  try {
    response = await chargePointService.getOpenChargingTransactionToken(chargePointId, identificationValue, last4Digit);

    dispatch({ type: chargePointActionTypes.GET_OPEN_CHARGING_TRANSACTION_SUCCESS });
  } catch (error) {
    response = error?.response;
    dispatch({
      type: chargePointActionTypes.GET_OPEN_CHARGING_TRANSACTION_FAILURE,
      payload: error.message || "Failed to fetch get open charging transaction.",
    });
  }
  return response?.data;
};

export const getChargingTransactionDetailsByToken = (token) => async (dispatch) => {
  let response;
  dispatch({ type: chargePointActionTypes.START_GET_CHARGING_TRANSACTION_DETAILS_BY_TOKEN });
  try {
    response = await chargePointService.getChargingTransactionDetailsByToken(token);

    dispatch({ type: chargePointActionTypes.GET_CHARGING_TRANSACTION_DETAILS_BY_TOKEN_SUCCESS });
  } catch (error) {
    response = error?.response;
    dispatch({
      type: chargePointActionTypes.GET_CHARGING_TRANSACTION_DETAILS_BY_TOKEN_FAILURE,
      payload: error.message || "Failed to fetch get  charging transaction.",
    });
  }
  return response?.data;
};

export const chargePointActions = {
  resetSelectedChargePoint,
  getChargePointBySerialNumber,
  getChargePointDetails,
  getChargePointDetailsByExternalIdentifiers,
  startChargingTransaction,
  stopChargingTransaction,
  getOpenChargingTransactionToken,
  getChargingTransactionDetailsByToken
};
